import UserResource from '@http/UserResource';

const userResource = new UserResource();

export default {
  namespaced: true,

  state: {
    users: [],
    pagination: {},
  },

  actions: {
    getUsers({commit}, params) {
      return userResource.getUsers(params)
        .then(({data}) => {
          commit('setAll', data.data);
          commit('setPagination', data.meta);

          return Promise.resolve(true);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },

    createUser(_, payload) {
      return userResource.createUser(payload)
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },

    updateUser(_, {id, payload}) {
      return userResource.updateUser(id, payload)
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    }
  },

  mutations: {
    setAll(state, users) {
      state.users = users;
    },

    setPagination(state, page) {
      state.pagination = page;
    },
  },

  getters: {
    users(state) {
      return state.users;
    },

    pagination(state) {
      return state.pagination;
    },
  }

};
